import { lazy } from "react";

const Mongabay = lazy(() => import("./mongabay/Mongabay"));
const Plenamata = lazy(() => import("./plenamata/Plenamata"));
const Refarm = lazy(() => import("./refarm/Refarm"));
const Pasto = lazy(() => import("./pasto/Pasto"));
const Direitos = lazy(() => import("./direitos/Direitos"));
const Rhino = lazy(() => import("./rhino/Rhino"));
const Vozes = lazy(() => import("./vozes/Vozes"));
const Olhar = lazy(() => import("./olhar/Olhar"));
const Guia = lazy(() => import("./guia/Guia"));
const Sitawi = lazy(() => import("./sitawi/Sitawi"));
const Mata = lazy(() => import("./mata/Mata"));
const VozesIn = lazy(() => import("./vozesin/VozesIn"));
const Plastico = lazy(() => import("./plastico/Plastico"));
const Captura = lazy(() => import("./captura/Captura"));
const Despolarize = lazy(() => import("./despolarize/Despolarize"));
const Alianza = lazy(() => import("./alianza/Alianza"));
const Clima = lazy(() => import("./clima/Clima"));
const Forest = lazy(() => import("./forest/Forest"));
const Populacao = lazy(() => import("./populacao/Populacao"));
const P4f = lazy(() => import("./p4f/P4f"));
const Facanhas = lazy(() => import("./facanhas/Facanhas"));
const Solidaria = lazy(() => import("./solidaria/Solidaria"));
const Agricultura = lazy(() => import("./agricultura/Agricultura"));
const MareDeCiencia = lazy(() => import("./mare-de-ciencia/MareDeCiencia"));
const Alziras = lazy(() => import("./alziras/Alziras"));
const Revolusolar = lazy(() => import("./revolusolar/Revolusolar"));
const Mobilizacao = lazy(() => import("./mobilizacao/Mobilizacao"));
const FundingThePlanetsGuardians = lazy(() => import("./funding-the-planets-guardians/FundingThePlanetsGuardians"));
const Promar = lazy(() => import("./promar/Promar"));
const Seminario = lazy(() => import("./seminario/Seminario"));
const TrabalhoJustoParaMulheres = lazy(() => import("./trabalho-justo-para-mulheres/TrabalhoJustoParaMulheres"));

export {
  Mongabay,
  Plenamata,
  Refarm,
  Pasto,
  Direitos,
  Rhino,
  Vozes,
  Olhar,
  Guia,
  Sitawi,
  Mata,
  VozesIn,
  Plastico,
  Captura,
  Despolarize,
  Alianza,
  Clima,
  Forest,
  Populacao,
  P4f,
  Facanhas,
  Solidaria,
  Agricultura,
  MareDeCiencia,
  Alziras,
  Revolusolar,
  Mobilizacao,
  FundingThePlanetsGuardians,
  Promar,
  Seminario,
  TrabalhoJustoParaMulheres,
}
